module.exports = __webpack_public_path__ + "img/alessia.b023fcc7.png";